import { Capacitor } from '@capacitor/core'
import { Filesystem } from '@capacitor/filesystem'

/**
 * 앱 시작 시 또는 필요한 시점에 호출할 권한 체크 및 요청 함수
 */
export async function checkAndRequestAllPermissions(): Promise<boolean> {
  if (Capacitor.getPlatform() !== 'android') return true

  try {
    // 기본 저장소 권한 확인 및 요청
    await Filesystem.checkPermissions()
    const result = await Filesystem.requestPermissions()

    if (result.publicStorage !== 'granted') {
      console.error('기본 저장소 권한이 거부됨')
      return false
    }

    return true
  } catch (error) {
    console.error('권한 확인 중 오류 발생:', error)
    return false
  }
}
